import { render, staticRenderFns } from "./EditarDerivacion.vue?vue&type=template&id=4dafa374"
import script from "./EditarDerivacion.vue?vue&type=script&lang=js"
export * from "./EditarDerivacion.vue?vue&type=script&lang=js"
import style0 from "./EditarDerivacion.vue?vue&type=style&index=0&id=4dafa374&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports